import { render, staticRenderFns } from "./Estudantes-foraTurma.vue?vue&type=template&id=16f97c26&scoped=true&"
import script from "./Estudantes-foraTurma.vue?vue&type=script&lang=js&"
export * from "./Estudantes-foraTurma.vue?vue&type=script&lang=js&"
import style0 from "./Estudantes-foraTurma.vue?vue&type=style&index=0&id=16f97c26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f97c26",
  null
  
)

export default component.exports